import {convertStringToDate} from './ConvertStringToDate';

export const validateBirthdate = (dateOfBirth) => {
  console.log('validateBirthdate called', dateOfBirth)

  const parsedDate = dateOfBirth && convertStringToDate(dateOfBirth, "dateOnly");
  if (!parsedDate) return false;

  const birthYear = parsedDate.getFullYear();
  const currentYear = new Date().getFullYear();

  const minAge = 12;
  const maxAge = 100;

  const age = currentYear - birthYear;

  const isValid = age > minAge && age < maxAge;
  return isValid;

};

// let dateIsInvalid = true
// if (dateOfBirth && convertStringToDate(dateOfBirth,"dateOnly")) {
//
//   const birthYear = convertStringToDate(dateOfBirth,"dateOnly").getFullYear()
//   const currentYear = new Date().getFullYear()
//   console.log('compare birthdates: ', birthYear, currentYear)
//
//   let minAge = 12
//   let maxAge = 100
//
//   if ((currentYear - birthYear > minAge) && (currentYear - birthYear < maxAge)) {
//     // date is valid
//     dateIsInvalid = false
//     // console.log('---> ', birthYear, new Date().getFullYear())
//   }
// }
//
// return dateIsInvalid
